import { companyInfo } from '../../../data';

export function Logo() {
    const logoPath = `${process.env.PUBLIC_URL || ''}${companyInfo.partner.logoPath}`;

    return (
        <div className="logo-container flex flex-col md:flex-row items-center justify-between w-full gap-4 py-4">
            <div className="flex flex-col items-center md:items-start justify-center">
                <h1 className="font-font-s font-bold text-main-color text-center md:text-left text-2xl md:text-4xl">
                    {companyInfo.name}
                </h1>
                <a
                    className="font-font-s italic font-medium text-main-color/80 text-center md:text-left text-xs lowercase hover:text-main-color transition-colors"
                    href={companyInfo.registrationUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Inregistrat in Registrul Asistentilor in Brokeraj Persoane Juridica, Cod:{' '}
                    <span className="uppercase font-semibold">{companyInfo.registrationCode}</span>
                </a>
            </div>

            <div className="flex flex-col items-center md:items-end">
                <p className="font-font-s text-sm font-semibold text-main-color/80 text-center md:text-right">
                    PARTENER FRANCIZAT
                </p>
                <a
                    className="flex items-center justify-center md:justify-end"
                    href={companyInfo.partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src={logoPath}
                        alt={companyInfo.partner.shortName}
                        className="w-[120px] md:w-[150px]"
                    />
                </a>
            </div>
        </div>
    );
}
